// Body.js

import React, { useEffect, useState } from "react";
import PleaseContactAdmin from "../components/PleaseContactAdmin";
import displayNavOptions from "../const/components";
import Loader from "./Loader";


// Body component
const Body = ({ selectedOption, setSelectedOption, navOptions }) => {
  const [initialLoad, setInitialLoad] = useState(true);
  const [isLoading, setLoading] = useState(true);

  const loaderDelay = 1000; // Example: 3000 milliseconds (3 seconds)

  useEffect(() => {
    // Check if initial load is complete
    if (!initialLoad) {
      setLoading(true); // Show loader on subsequent renders
    }
  }, [initialLoad]);

  useEffect(() => {
    // Check if initial load is complete
    if (!initialLoad) {
      const timeout = setTimeout(() => {
        setLoading(false); // Hide loader after delay
      }, loaderDelay);

      return () => clearTimeout(timeout);
    }
  }, [initialLoad, loaderDelay]);

  // Determine if the selected option is valid and visible
  const isValidOption = navOptions.some(
    (option) => option.optionVal === selectedOption && option.visible
  );

  // Handle invalid selected option scenario
  useEffect(() => {
    if (!isValidOption && navOptions.length > 0 && !initialLoad) {
      const firstVisibleOption = navOptions.find((option) => option.visible);
      if (firstVisibleOption) {
        setSelectedOption(firstVisibleOption.optionVal);
        localStorage.setItem("navOption", firstVisibleOption.optionVal);
      }
    }
  }, [isValidOption, navOptions, initialLoad, setSelectedOption]);

  // Once initialization is done, set initialLoad to false
  useEffect(() => {
    if (initialLoad) {
      setInitialLoad(false);
    }
  }, [initialLoad]);

  // Determine which component to display based on validity
  const componentToDisplay = isValidOption ? (
    displayNavOptions[selectedOption].component
  ) : (
    <PleaseContactAdmin />
  );

  return (
    <div className="flex-1">
      <div className="container p-4 mx-auto">
        {isLoading ? <Loader delay={loaderDelay} /> : componentToDisplay}
      </div>
    </div>
  );
};

export default Body;
